import {useTranslation} from "react-i18next";
import Skeleton from "react-loading-skeleton";
import Navbar from "../../components/navbar";
import {FormButton} from "../../components/_input/_button";
import {InputField} from "../../components/_input/_input";
import ThemeContext from "../../utils/contexts/themeContext";
import {EvaluationType} from "./components/EvaluationType";
import {useParams} from 'react-router-dom'
import axios from 'axios'
import Popup from '../../components/popup'
import {Icons, toast} from "react-toastify";
import {useCallback, useEffect, useState, useContext, Suspense, useRef} from 'react'
import {use} from "i18next";
import {FormControl, FormLabel} from "react-bootstrap";
import config from "../../configuration/config.json";

export const ServiceEvaluationPage = (callbackfn, thisArg) => {
    const [isLoadingStatus, setIsLoadingStatus] = useState(true);
    const [fixAgreement, setFixAgreement] = useState({});
    const [questions, setQuestions] = useState([]);
    const [Mandatoryquestions, setMandatoryQuestions] = useState([]);
    const themeMode = useContext(ThemeContext);
    const [evaluations, setEvaluations] = useState({});
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [description, setDescription] = useState("");
    const popRef = useRef(null)
    const {t: trans, i18n} = useTranslation([
        "mobileCommon",
        "new",
        "ServiceEvaluation",
        "fixAgreemnet",
        "mobileMessages"
    ]);
    let lang = i18n.language;
    const {number} = useParams();
    const [listError, setListEror] = useState([]);

    const [changeCHa, setChangeCHa] = useState(false);
    const [listObjectQA, setListObjectQA] = useState({});

    const [errorMessage, setErrorMessage] = useState(false);
    
    const [isTextForClick, setIsTextForClick] = useState(0);
    const [clickAnsAr, setClickAnsAr] = useState('');
    const [clickAnsEn, setClickAnsEn] = useState('');
    const [descriptionQID3, setDescriptionQID3] = useState("");
    const [descriptionQID4, setDescriptionQID4] = useState("");
    const [QuID, setQuID] = useState(0);
    const [TextYesNoFlag, setTextYesNoFlag] = useState(false);

    const [showText, setShowText] = useState({})
    
    
    const SetAnseQ = (checked, columnAR, columnEN, guid, valueAR, valueEN, typeQ = 3, MandatoryQuestions, TextYesNoFlag = '',hasText= false, quId= 0) => {

        if (typeQ == 3) {
            var object = {};
            if (listObjectQA[guid] != null) {
                object = {...listObjectQA[guid]}
            }
            if (checked) {
                object[columnAR] = valueAR;
                object[columnEN] = valueEN;

                object["QTypeID"] = typeQ;
                object["Mandatory"] = MandatoryQuestions;
                // object["Note"] = description;

            } else {
                object[columnAR] = 0;
                object[columnEN] = 0;

                object["QTypeID"] = typeQ;
                object["Mandatory"] = MandatoryQuestions;
                // object["Note"] = description;
            }

            var mainJson = {...listObjectQA};
            mainJson[guid] = object;

            console.log("mainJson", mainJson);
            setListObjectQA(mainJson);

        } else if (typeQ == 2) {
            var object = {};

            object[columnAR] = valueAR;
            object[columnEN] = valueEN;
            object["QTypeID"] = typeQ;
            object["Mandatory"] = MandatoryQuestions;
            object["QID"] = quId;
            
            object["hasText"] = hasText;
            object["TextYesNo"] = TextYesNoFlag;
            
            if (hasText == true){
                // object["hasText"] = true;
            }

            var mainjsion = {...listObjectQA};
            mainjsion[guid] = object;

            console.log("mainjs", mainjsion);
            setListObjectQA(mainjsion);

        } else if (typeQ == 1) {
            var object = {};
            if (listObjectQA[guid] != null) {
                object = {...listObjectQA[guid]}
            }
            if (checked) {
                object[columnAR] = valueAR;
                object[columnEN] = valueEN;
                object["QTypeID"] = typeQ;
                object["Mandatory"] = MandatoryQuestions;
                // object["Note"] = description;

            } else {
                object[columnAR] = null;
                object[columnEN] = null;
                object["QTypeID"] = typeQ;
                object["Mandatory"] = MandatoryQuestions;
                // object["Note"] = description;
            }

            var mainjsion = {...listObjectQA};
            mainjsion[guid] = object;

            console.log("mainjs", mainjsion);
            setListObjectQA(mainjsion);
        } else if (typeQ == 5 || typeQ == 0) {
            // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj@@ type\n", typeQ)
            // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj@@ guid\n", guid)
            // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj@@ valueAR\n", valueAR)

            var object = {};

            object[columnAR] = valueAR;
            object[columnEN] = valueEN;
            object["QTypeID"] = typeQ;

            var mainjsion = {...listObjectQA};
            mainjsion[guid] = object;

            console.log("mainjs", mainjsion);
            setListObjectQA(mainjsion);
        }
    };

    const handelClickBtn = () => {
        var _keysList = Object.keys(listObjectQA);
        console.log("Mandatoryquestions: ", Mandatoryquestions);
        console.log("_keysList: ", _keysList);

        let obQST;
        _keysList.forEach((value, key) => {
            obQST = listObjectQA[value];

            if (obQST["QTypeID"] == 3) {
                if (obQST["Answer1Choice"] == null) {
                    obQST["Answer1Choice"] = 0;
                }
                if (obQST["Answer2Choice"] == null) {
                    obQST["Answer2Choice"] = 0;
                }
                if (obQST["Answer3Choice"] == null) {
                    obQST["Answer3Choice"] = 0;
                }
            }
        });

        console.log("listObjectQA => After_lop: ", listObjectQA);

        var notFound = Mandatoryquestions.filter(val => !_keysList.includes(val));
        console.log("notFound: ", notFound);

        if (notFound.length == 0) {

            var _valList = Object.values(listObjectQA);
            if (_valList.length != 0) {

                console.log("listObjectQA{_valList.length != 0} >>>> ", listObjectQA);
                sendEvaluations();

                // if ( description.length < 1) {
                //   toast.warning(lang == "ar"
                //       ? "من فضلك قم بكتابة ملاحظة ! "
                //       :"Please write your comment !");
                // }else {
                //   console.log("@@@ sendEvaluations: ", listObjectQA);
                //    sendEvaluations();
                // }

            } else {
                let tx = lang == "ar"
                    ? "تأكد من اختيار إجابة للأسئلة الإلزامية!"
                    : "Make sure to choose an answer to the mandatory questions!";

                console.log(tx, "  >>>>>>>>", listObjectQA);
                toast.warning(tx);

            }

        } else {

            console.log("listError: ", notFound);
            setListEror(notFound);
        }
    };


    const initCallback = useCallback(async () => {
        try {
            console.log("initCallback :");
            setShowFinalPopup(false);
            if (number) {
                axios.post(`${config.controllerUrl}${lang}/api/Maintenance/GetServiceEvaluation/${number}`)
                    .then(response => {
                        console.log("GetServiceEvaluation :", response);
                        if (response.status === 200) {
                            setIsLoadingStatus(false);
                            checkEvaluations(response?.data?.intro?.orderNo);

                            if (!response?.data?.intro)
                                setShowFinalPopup(true);
                            
                            setFixAgreement(response?.data);

                            //GetQuestions(response?.data?.intro?.orderNo); //todo: نرجع نفس ماكان
                            // checkEvaluations(response?.data?.intro?.orderNo);
                            // GetQuestions("JobOrd-2023/05/0123 ");

                        } else {

                            setShowFinalPopup(true);
                        }
                    }).catch(error => {
                    console.log(error);
                    console.log("ERROR Catch: Maintenance/fixAgreement", error.response.data.messageNo);
                    setErrorMessage(true);
                    setShowFinalPopup(true);
                    setIsLoadingStatus(false);
                });
            }
        } catch (e) {
            console.log(e);
            setShowFinalPopup(true);
            setIsLoadingStatus(false);
        }
    }, []);


    const GetQuestions = useCallback(async (JobCardID) => {
        try {

            //Evaluation Mandatory QDescEn

            axios.post(`${config.controllerUrl}${lang}/api/Maintenance/Questions/${JobCardID.replaceAll("/", ",")}`)
                .then(response => {
                    if (response.status === 200) {

                        setQuestions(response?.data);

                        var cuMan = [];
                        response?.data.map((item, index) => {

                            if (item.Mandatory)
                                cuMan = [item?.GUID, ...cuMan];

                        });
                        setMandatoryQuestions([...cuMan])
                    }
                }).catch(error => {
                console.log(error);
            });

        } catch (e) {
            console.log(e);
        }
    }, []);

    const checkEvaluations = (async (JobCardID) => {
        try {

            if (JobCardID) {
                await axios.request({
                    url: `${config.controllerUrl}${lang}/api/Maintenance/CheckEvaluations/${JobCardID.replaceAll("/", ",")}`,
                    data: listObjectQA, method: "POST", responseType: "json"
                }).then(response => {
                    //   
                    console.log("response :", response);

                    if (response.status >= 200 && response.status <= 299) {
                        console.log("response.data :", response.data);
                        if (response.data) {
                            console.log("response.data.COUNT_ROW :", response.data.COUNT_ROW);
                            if (response.data.COUNT_ROW > 0) {
                                console.log("response.data.COUNT_ROW < 0 :", response.data.COUNT_ROW);
                                GetQuestions(JobCardID);
                                setShowFinalPopup(false);
                            } else {
                                console.log("response.data.COUNT_ROW > 0 :", response.data.COUNT_ROW);
                                setShowFinalPopup(true); // Dele
                            }
                        }
                    } else if (response.status >= 400 && response.status <= 599) {
                        console.log("response.statusText:", response.statusText);
                        // if (response.data){
                        console.log("response.status :", response.status);
                        // }
                    }

                }).catch(error => {
                    // نضيف التواست
                    setShowFinalPopup(true); // Dele
                    console.warn("catch axios error: ", error);
                });
            }

        } catch (ex) {
            console.log("catch error ex: ", ex);
        }
    });

    const sendEvaluations = useCallback(async () => {

        try {
            // console.log("nextStepCallback @>>>>> :", evaluations);
            // console.log("description @>>>>>>>>>> :", description);

            // var orderNo = fixAgreement?.intro?.orderNo;
            // evaluations["note"]=orderNo;
            var JobCardID = fixAgreement.intro?.orderNo;
            if (JobCardID) {
                axios.request({
                    url: `${config.controllerUrl}${lang}/api/Maintenance/sendEvaluations/${JobCardID.replaceAll("/", ",")}`,
                    data: listObjectQA, method: "POST", responseType: "json"
                }).then(response => {
                    console.log("response :", response);
                    if (response.status === 200) {
                        if (response?.data) {
                            setShowFinalPopup(true);
                            UpdateEvaluationDone();
                        }
                    }

                }).catch(error => {
                    // نضيف التواست
                });
            }

        } catch (e) {
            console.log(e);

        }
    }, [description, evaluations, listObjectQA]);

    const MntcUpdatePSFUHeader = async (guid) => {
        try {
            var JobCardID = fixAgreement.intro?.orderNo;
            if (JobCardID) {
                await axios.request({
                    url: `${config.controllerUrl}${lang}/api/Maintenance/MntcUpdatePSFUHeader/${guid}`,
                    data: listObjectQA, method: "POST", responseType: "json"
                }).then(response => {
                    console.log("response :", response);

                    if (response.status >= 200 && response.status <= 299) {
                        setShowFinalPopup(true);
                        if (response.data) {
                            console.log(response.data);
                        }
                    } else {
                        console.log("response.statusText:", response.statusText);
                        console.log("response.status :", response.status);
                    }
                }).catch(error => {
                    console.warn("catch axios error: ", error);
                });
            }
        } catch (ex) {
            console.log("catch error ex", ex);
        }
    }

    const UpdateEvaluationDone = async () => {
        try {
            var JobCardID = fixAgreement.intro?.orderNo;
            if (JobCardID) {
                await axios.request({
                    url: `${config.controllerUrl}${lang}/api/Maintenance/UpdateEvaluationDone/${JobCardID.replaceAll("/", ",")}`,
                    data: listObjectQA, method: "POST", responseType: "json"
                }).then(response => {
                    console.log("response :", response);

                    if (response.status >= 200 && response.status <= 299) {
                        console.log("response.data :", response.data);
                        console.log("response.status :", response.status);
                        console.log("response.statusText:", response.statusText);
                        setShowFinalPopup(true); // Dele
                        
                        MntcUpdatePSFUHeader(number);
                        
                        if (response.data) {
                        }
                        
                    } else {
                        console.log("response.statusText:", response.statusText);
                        console.log("response.status :", response.status);
                    }
                }).catch(error => {
                    // نضيف التواست
                    console.warn("catch axios error: ", error);
                });
            }
        } catch (ex) {
            console.log("catch error ex", ex);
        }
    }

    useEffect(() => {
        initCallback();
        // checkEvaluations();
    }, []);

    // const opjectQTest = {
    //   id:2,
    //   GUID:"1234565",
    //   questionsAr:"بناء على اختيارك تسليم السيارة, هل ينكنك الاشارة الى الاسباب المتعلقة؟",
    //   ansAr:[
    //       {text:"1اجابة",guid:"duid"},
    //       {text:"2اجابة",guid:"duid"},
    //       {text:"3اجابة",guid:"duid"},
    //       {text:"4اجابة",guid:"duid"},
    //   ],
    //   questionsEn:"questions EnquestionsEn?",
    //   ansEn:
    //       [
    //         {text:"ansuar1",guid:"duid"},
    //         {text:"ansuar2",guid:"duid"},
    //         {text:"ansuar3",guid:"duid"},
    //         {text:"ansuar4",guid:"duid"},
    //       ],
    //   type:"checkbox"
    // }
    //
    // const opjectQTestRadio = {
    //   id:2,
    //   GUID:"123456",
    //   questionsAr:"بناء على اختيارك تسليم السيارة, هل ينكنك الاشارة الى الاسباب المتعلقة؟",
    //   ansAr:[
    //     {text:"نعم",guid:"duid"},
    //     {text:"لا",guid:"duid"},
    //   ],
    //   questionsEn:"questions EnquestionsEn?",
    //   ansEn: [
    //     {text:"ok",guid:"duid"},
    //     {text:"no",guid:"duid"},
    //   ],
    //   type:"radio"
    // }
    // const listQTest = [opjectQTestRadio,opjectQTest,opjectQTestRadio,opjectQTest,opjectQTest,]
    // const [testQ, settestQ] = useState({ textA:"س1",textE:"Q1", checed:true });
    // const [testLQ, settestLQ] = useState([ testQ,testQ,testQ ]);


    return isLoadingStatus ? (
        <>
            <Skeleton
                count={1}
                borderRadius={"1rem"}
                width={"100%"}
                height={"10rem"}
                containerClassName={"my-5"}
                className={"flex my-5"}
                inline={false}
            />

            <Skeleton
                count={1}
                borderRadius={"1rem"}
                width={"100%"}
                height={"50rem"}
                containerClassName={"my-5"}
                className={"flex my-5"}
                inline={false}
            />

            <Skeleton
                count={1}
                borderRadius={"1rem"}
                width={"100%"}
                height={"50rem"}
                containerClassName={"my-5"}
                className={"flex my-5"}
                inline={false}
            />

            <Skeleton
                count={10}
                borderRadius={"1rem"}
                width={"70%"}
                height={"5rem"}
                containerClassName={"my-5"}
                className={"flex my-5"}
                inline={false}
            />

            <Skeleton
                count={2}
                borderRadius={"1rem"}
                width={"50%"}
                height={"10rem"}
                containerClassName={"flex flex-row nice-gap-2rem my-20"}
                className={"flex flex-row nice-gap-2rem my-20"}
                inline={true}
            />
        </>
    ) : (
        <div className={`theme-${themeMode}`}>
            <Navbar title={trans("ServiceEvaluation:page_title")}/>
            <>
                <div className="nice-container flex flex-col nice-gap-1rem mt-28">
                    <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-bold text-nowrap text-capitalize">
              {trans('fixAgreemnet:agreement_number')}:
            </span>
                        <span className="text-30 text-bold">{fixAgreement?.intro?.orderNo}</span>
                    </div>
                    <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-bold text-nowrap text-capitalize">
              {trans("ServiceEvaluation:host_name")}:
            </span>


                        <span className="text-30 text-bold"> {fixAgreement?.host?.vehOwner} </span>

                        <span className="text-30 text-bold"></span>
                    </div>

                    <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans("ServiceEvaluation:mobile_number")}:
            </span>
                        <span
                            className="text-30">   {fixAgreement != null ? fixAgreement?.host?.ownerMobile : ''} </span>
                        <span className="text-30"></span>
                    </div>

                    <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans('fixAgreemnet:reception_engineer')}:
            </span>
                        <span className="text-30 line-break" dir="ltr">
              {fixAgreement?.intro?.receiverFullName}
            </span>
                    </div>
                    <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans('new:mobile')}:
            </span>
                        <span className="text-24 text-bold text-info-light language-en" dir="ltr">
              {fixAgreement?.intro?.empMobile && <a
                  className="text-30 text-bold text-info-light language-en border-line-b"
                  href={'tel:' + fixAgreement?.intro?.empMobile}
              >
                  {fixAgreement?.intro?.empMobile}
              </a>
              }
            </span>
                    </div>

                    <div className="ruler-gray my-10 mx-auto"></div>

                    {
                        questions.map((item, index) => {
                            return (
                                item.QTypeID == 1 && (
                                    <>
                                        <EvaluationType
                                            key={index}
                                            title={lang == "ar" ? item?.QDescAr : item?.QDescEn}
                                            mandatory={item?.Mandatory}
                                            error={listError.includes(item.GUID) ? trans("mobileMessages:field_required") : null}
                                            click={(val) => {

                                                var evalua = {...evaluations};
                                                evalua[item.GUID] = val;
                                                // avg = avg + val;
                                                setEvaluations(evalua);
                                                SetAnseQ(
                                                    true,
                                                    "Evaluation",
                                                    "Evaluation",
                                                    item.GUID,
                                                    val,
                                                    val,
                                                    1,
                                                    item.Mandatory
                                                );
                                            }}
                                        />
                                        <div className="ruler-gray my-10 mx-auto"></div>
                                    </>
                                )
                            )
                        })
                    }

                    {
                        questions.map((item, index) => {
                            return (
                                item.QTypeID == 2 && (
                                    <>
                                        <h1 className="serviceEvaluation-section-title pb-11" key={index}>
                                            {lang == 'ar' ? item.QDescAr : item.QDescEn}
                                            {item.Mandatory && <span
                                                className="text-danger serviceEvaluation-section-title star-red"> {"*"}</span>}
                                            {
                                                listError.includes(item.GUID) &&
                                                <span className="text-danger serviceEvaluation-section-title">&nbsp;
                                                    {trans("mobileMessages:field_required")}
                                                </span>
                                            }
                                        </h1>
                                        
                                        <div 
                                            className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5${changeCHa == false ? '' : 'is-border'} `}>
                                            <input
                                                type={'radio'}
                                                id={1}
                                                name={item.GUID}
                                                value={lang == 'ar' ? item.Answer1Ar : item.Answer1En}
                                                // checked={ true }
                                                onChange={(event) => {
                                                    console.log(event.target.value);
                                                    setChangeCHa(event.target.checked);
                                                    SetAnseQ(
                                                        true,
                                                        "AnswerAr",
                                                        "AnswerEn",
                                                        item.GUID,
                                                        item.Answer1Ar,
                                                        item.Answer1En,
                                                        2,
                                                        item.Mandatory,
                                                        descriptionQID3,
                                                        item.TextYesNoFlag,
                                                        item.QID
                                                    );
                                                    if(item.TextYesNoFlag == true){
                                                        setIsTextForClick(index);
                                                        setTextYesNoFlag(item.TextYesNoFlag)
                                                        setClickAnsAr(item.Answer1Ar);
                                                        setClickAnsEn(item.Answer1En);
                                                        setQuID(item.QID);
                                                        let sh = showText;
                                                        sh[item.GUID] = true;
                                                        setShowText(sh);
                                                    }
                                                }}
                                                className={"text-primary"}
                                                title={"test"}
                                            />
                                            <label className="text-30  flex flex-row  pr-10 pl-20">
                                                {lang == 'ar' ? item.Answer1Ar : item.Answer1En}
                                            </label>
                                        </div>
                                        {
                                            (item.TextYesNoFlag === true  && showText[item.GUID] == true)
                                                ? 
                                                <div key={index}>
                                                    <InputField
                                                        labelStyle="text-40 serviceEvaluation-section-map-item false box-serviceEvaluation"
                                                        placeholder={trans("ServiceEvaluation:write_note_placeholder")}
                                                        onChangeValue={(event) => {
                                                            setDescriptionQID3(event.target.value);
                                                            //console.log("input >>>>>>>>>>>>>>>>>>>>>", event.target.value.length.toString())
                                                            SetAnseQ(
                                                                false,
                                                                'AnswerAr',
                                                                'AnswerEn',
                                                                item.GUID,
                                                                clickAnsAr,
                                                                clickAnsEn,
                                                                2,
                                                                false,
                                                                event.target.value,
                                                                true,
                                                                item.QID
                                                            );
                                                        }}
                                                        extraClasses="serviceEvaluation-text-note-input"
                                                    />
                                                </div> :<span></span>
                                        }
                                        <div className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5
                                  ${changeCHa < 0 ? '' : 'is-border'} `}>
                                            <input
                                                type={'radio'}
                                                id={2}
                                                name={item.GUID}
                                                value={lang == 'ar' ? item.Answer2Ar : item.Answer2En}
                                                // checked={ true }
                                                onChange={(event) => {
                                                    // setChangeCHa(index);
                                                    // console.log(`Q id:${item.id} index Q: ${index}, text: ${item.Answer1Ar.text}, index: ${item.QID}`);
                                                    console.log(event.target.value);
                                                    SetAnseQ(
                                                        true,
                                                        "AnswerAr",
                                                        "AnswerEn",
                                                        item.GUID,
                                                        item.Answer2Ar,
                                                        item.Answer2En,
                                                        2,
                                                        item.Mandatory,
                                                        '',
                                                        item.TextYesNoFlag,
                                                        item.QID
                                                    );
                                                    if(item.TextYesNoFlag == true) {
                                                        let sh = showText;
                                                        sh[item.GUID] = false;
                                                        setShowText(sh);
                                                        setDescriptionQID3('');
                                                    }
                                                }}
                                                className={"text-primary"}
                                            />
                                            <label className="text-30  flex flex-row  pr-10 pl-20">
                                                {lang == 'ar' ? item.Answer2Ar : item.Answer2En}
                                            </label>
                                        </div>

                                        {
                                            (
                                                (item.Answer3Aa != null && item.Answer3En != null) &&
                                                (item.Answer3Aa.trim() != '' && item.Answer3En.trim() != '')
                                            )
                                            && (
                                                <div className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5 
                                                    ${changeCHa < 0 ? '' : 'is-border'} `}>
                                                    <input
                                                        type={'radio'}
                                                        id={3}
                                                        name={item.GUID}
                                                        value={lang == 'ar' ? item.Answer3Ar : item.Answer3En}
                                                        // checked={ true }
                                                        onChange={(event) => {
                                                            SetAnseQ(
                                                                true,
                                                                "AnswerAr",
                                                                "AnswerEn",
                                                                item.GUID,
                                                                item.Answer3Ar,
                                                                item.Answer3En,
                                                                2,
                                                                item.Mandatory
                                                            );
                                                            console.log(event.target.value);
                                                        }}
                                                        className={"text-primary"}
                                                        title={"test"}
                                                    />
                                                    <label className="text-30  flex flex-row  pr-10 pl-20">
                                                        {lang == 'ar' ? item.Answer3Ar : item.Answer3En}
                                                    </label>
                                                </div>
                                            )
                                        }
                                        <div className="ruler-gray my-10 mx-auto"></div>
                                    </>
                                )
                            )
                        })
                    }

                    {
                        questions.map((item, index) => {
                            return (
                                item.QTypeID == 3 && (
                                    <>
                                        <h1 className="serviceEvaluation-section-title pb-11" key={index}>
                                            {lang == 'ar' ? item.QDescAr : item.QDescEn}
                                            {item.Mandatory && <span
                                                className="text-danger serviceEvaluation-section-title star-red">{"*"}</span>}
                                            {
                                                listError.includes(item.GUID) &&
                                                <span className="text-danger serviceEvaluation-section-title">
                                            &nbsp; {trans("mobileMessages:field_required")}
                                      </span>
                                            }
                                        </h1>

                                        <div className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5
                                  ${changeCHa < 0 ? '' : 'is-border'} `}>
                                            <input
                                                type={'checkbox'}
                                                id={1}
                                                name={item.GUID}
                                                value={lang == 'ar' ? item.Answer1Ar : item.Answer1En}
                                                onChange={(event) => {

                                                    console.log("checked", event.target.checked ? "ok" : "");
                                                    console.log("value: ", event.target.value);

                                                    // setAnswer1Choice( event.target.checked == true ? 1: 0);

                                                    SetAnseQ(
                                                        event.target.checked,
                                                        "Answer1Choice",
                                                        "Answer1Choice",
                                                        item.GUID,
                                                        1,
                                                        1,
                                                        3,
                                                        item.Mandatory
                                                    );
                                                }}
                                                className={"text-primary"}
                                                title={"test"}
                                            />
                                            <label
                                                className="text-30  flex flex-row  pr-10 pl-20">{lang == 'ar' ? item.Answer1Ar : item.Answer1En}</label>
                                        </div>

                                        <div className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5
                                  ${changeCHa < 0 ? '' : 'is-border'} `}>
                                            <input
                                                type={'checkbox'}
                                                id={2}
                                                name={item.GUID}
                                                value={lang == 'ar' ? item.Answer2Ar : item.Answer2En}
                                                // checked={ true }
                                                onChange={(event) => {

                                                    // setAnswer2Choice( event.target.checked == true ? 1: 0);

                                                    SetAnseQ(
                                                        event.target.checked,
                                                        "Answer2Choice",
                                                        "Answer2Choice",
                                                        item.GUID,
                                                        1,
                                                        1,
                                                        3,
                                                        item.Mandatory
                                                    );
                                                    // setChangeCHa(index);
                                                    // console.log(`Q id:${item.id} index Q: ${index}, text: ${item.Answer1Ar.text}, index: ${item.QID}`);
                                                    console.log(event.target.value);
                                                }}
                                                className={"text-primary"}
                                                title={"test"}
                                            />
                                            <label
                                                className="text-30  flex flex-row  pr-10 pl-20">{lang == 'ar' ? item.Answer2Ar : item.Answer2En}</label>
                                        </div>

                                        <div className={`serviceEvaluation-section-map-item false box-serviceEvaluation mb-5
                                  ${changeCHa < 0 ? '' : 'is-border'} `}>
                                            <input
                                                type={'checkbox'}
                                                id={3}
                                                name={item.GUID}
                                                value={lang == 'ar' ? item.Answer3Ar : item.Answer3En}
                                                // checked={ true }
                                                onChange={(event) => {
                                                    console.log(event.target.checked == true ? "tt" : "ff");
                                                    // setAnswer3Choice( event.target.checked == true ? 1: 0);
                                                    SetAnseQ(
                                                        event.target.checked,
                                                        "Answer3Choice",
                                                        "Answer3Choice",
                                                        item.GUID,
                                                        1,
                                                        1,
                                                        3,
                                                        item.Mandatory
                                                    );
                                                    // setChangeCHa(index);
                                                    // console.log(`Q id:${item.id} index Q: ${index}, text: ${item.Answer1Ar.text}, index: ${item.QID}`);
                                                }}
                                                className={"text-primary"}
                                                title={"test"}
                                            />
                                            <label className="text-30  flex flex-row  pr-10 pl-20">
                                                {lang == 'ar' ? item.Answer3Ar : item.Answer3En}
                                            </label>
                                        </div>
                                        <div className="ruler-gray my-10 mx-auto"></div>
                                    </>
                                )
                            )
                        })
                    }

                    <InputField
                        title={trans("ServiceEvaluation:notes")}
                        labelStyle="text-40 serviceEvaluation-text-note"
                        placeholder={trans("ServiceEvaluation:write_note_placeholder")}
                        // value={description}
                        onChangeValue={(event) => {
                            setDescription(event.target.value);
                            //console.log("input >>>>>>>>>>>>>>>>>>>>>", event.target.value.length.toString())
                            SetAnseQ(
                                true,
                                "Note",
                                "Note",
                                `0000-${fixAgreement.intro?.orderNo}-0000`,
                                event.target.value,
                                event.target.value,
                                5,
                                true
                            );
                        }}
                        extraClasses="serviceEvaluation-text-note-input"
                    />
                    <div className="mb-10">
                       
                                <FormButton
                                    name={trans("ServiceEvaluation:evaluate")}
                                    classes="my-10 serviceEvaluation-btn"
                                    onClick={() => {
                                        // console.info(">>>>>>>>>>>>>>>>>>>>>>>>>>>", listObjectQA);
                                        handelClickBtn(listError);
                                    }}
                                />
                    </div>
                </div>
            </>


            <Suspense>
                <Popup show={showFinalPopup}>
                    <div className="w-full h-full flex justify-center items-center">
                        <div className="cart-finalized" ref={popRef}>
                            {/* <div className="popup-close nice-select-none" onClick={() => {

                                setShowFinalPopup(false);

                            }}>
                                {"x"}
                            </div> */}
                            <div className="cart-finalized-container">
                                <img src="/assets/images/finalized.svg"/>
                            </div>
                            <div className="flex flex-wrap justify-center">
                                <span className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>
                            <div className="flex flex-wrap justify-center">
                                {errorMessage== true && (
                                    <span className="text-34 font-bold text-gray mx-2"> {trans("new:evaluationMessage")}</span>
                                )}
                            </div>

                        </div>
                    </div>
                </Popup>
            </Suspense>
        </div>
    );
};
